import React from 'react';
import { Link } from 'react-router-dom';

const FLAG_COPY = {
  INSUFFICIENT_TRIALS: 'There were not enough usable responses to produce a score this time.',
};

function explain(flags) {
  if (!Array.isArray(flags)) return null;
  const known = flags.find((f) => FLAG_COPY[f]);
  return known ? FLAG_COPY[known] : null;
}

export default function AssessmentResults({ result }) {
  const measured = result?.score != null;
  const reason = explain(result?.flags);

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 1000,
        background: 'var(--bg-primary)',
        display: 'grid',
        placeItems: 'center',
        padding: 'var(--space-5)',
        overflowY: 'auto',
      }}
    >
      <div style={{ maxWidth: 420, textAlign: 'center' }}>
        <h1
          style={{
            fontSize: 'var(--text-numeric-size)',
            fontWeight: 700,
            color: 'var(--text-tertiary)',
            textTransform: 'uppercase',
            letterSpacing: 'var(--text-label-tracking)',
            marginBottom: 'var(--space-4)',
            margin: '0 0 var(--space-4)',
          }}
        >
          Assessment complete
        </h1>

        <div
          aria-label={measured ? `Score: ${Math.round(result.score)}` : 'Score not available'}
          style={{
            fontSize: 64,
            fontWeight: 800,
            color: measured ? 'var(--text-primary)' : 'var(--text-tertiary)',
            letterSpacing: '-0.03em',
            lineHeight: 1,
            marginBottom: 'var(--space-4)',
          }}
        >
          {measured ? Math.round(result.score) : '—'}
        </div>

        <p
          style={{
            margin: '0 auto var(--space-5)',
            maxWidth: 340,
            fontSize: 'var(--text-body-size)',
            color: 'var(--text-secondary)',
            lineHeight: 1.6,
          }}
        >
          {!measured
            ? reason || 'We could not produce a score from this run.'
            : result.isBaseline
              ? 'This is your starting point. It is not a good or a bad result — later runs measure how you move from here.'
              : 'Measured against your own starting point, not against anyone else.'}
        </p>

        <Link
          to="/g-score"
          style={{
            display: 'inline-block',
            padding: 'var(--space-3) var(--space-5)',
            borderRadius: 'var(--radius-md)',
            background: 'var(--btn-primary-bg)',
            color: 'var(--btn-primary-text)',
            fontSize: 'var(--text-body-size)',
            fontWeight: 700,
            textDecoration: 'none',
          }}
        >
          Done
        </Link>
      </div>
    </div>
  );
}
